import React from "react";
import Page from "../Components/Page";
import ControlsList from "../features/controls/ControlsList";
import { IControl } from "../features/controls/types";
import useFetchData from "../hooks/useFetchData";

export default function ControlsPage() {
  const { data: controls, isLoading } = useFetchData<IControl[]>("/controls");
  return (
    <Page isLoading={isLoading}>
      {controls && <ControlsList controls={controls} />}
    </Page>
  );
}
